import { useEffect, useState } from "react";

import { Select, SelectData, TextField } from "@king-ict/eupisi-ui/components";
import { CodeBook } from "@king-ict/eupisi-ui/models";
import { nameof } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { searchInstitutions, searchLocations } from "../../../api";
import { useTypedSelector } from "../../../app";
import {
  AdministrationListFiltersChildProps,
  AdministrationListFiltersData,
} from "../../../components";
import { useRequestStatuses } from "../../../hooks/requestStatus/useRequestStatuses";
import { RequestFilters, RequestCreatedByEnum } from "../../../models";
import styles from "./RequestSearchFilters.module.scss";

export const RequestSearchFilters = ({
  filters,
  onFilterChange,
}: AdministrationListFiltersChildProps<RequestFilters>) => {
  const [institutions, setInstitutions] = useState<CodeBook[]>([]);
  const [locations, setLocations] = useState<CodeBook[]>([]);
  const user = useTypedSelector((state) => state.application.user);
  const { t } = useTranslation();

  const requestStatuses = useRequestStatuses();
  
  useEffect(() => {
    (async () => {
      if (filters?.pedagogicalYearId) {
        const res = await searchInstitutions({
          pedagogicalYearId: filters?.pedagogicalYearId,
        } as AdministrationListFiltersData);
        setInstitutions(res);
      }
    })();
  }, [filters?.pedagogicalYearId, user.enrollmentGroupId]);


  useEffect(() => {
    (async () => {
      if (filters?.pedagogicalYearId && filters?.institutionId) {
        const res = await searchLocations({
          pedagogicalYearId: filters?.pedagogicalYearId,
          institutionId: filters?.institutionId
        });
        setLocations(res);
      }
    })();
  }, [filters?.pedagogicalYearId, filters?.institutionId, user.enrollmentGroupId]);

  return filters == null || onFilterChange == null ? null : (
    <>
      <Row className={styles.filterRow}>
        <Col md={6}>
          <TextField
            label={t("requestList.childOib")}
            name={nameof<typeof filters>("childOib")}
            value={filters.childOib}
            onChange={onFilterChange}
          />
        </Col>
        <Col md={6}>
          <TextField
            label={t("requestList.childLastName")}
            name={nameof<typeof filters>("childLastName")}
            value={filters.childLastName}
            onChange={onFilterChange}
          />
        </Col>
      </Row>
      <Row className={styles.filterRow}>
        <Col md={6}>
          <TextField
            label={t("requestList.applicantOib")}
            name={nameof<typeof filters>("applicantOib")}
            value={filters.applicantOib}
            onChange={onFilterChange}
          />
        </Col>
        <Col md={6}>
          <Select
            multiple
            label={t("requestList.requestStatus")}
            name={nameof<typeof filters>("requestStatusIds")}
            value={filters.requestStatusIds || []}
            onChange={onFilterChange}
            emptyOption={{ value: undefined, text: "" }}
            selectData={
              {
                valueProp: "id",
                textProp: "name",
                data: requestStatuses,
              } as SelectData<CodeBook>
            }
          />
        </Col>
      </Row>
      <Row className={styles.filterRow}>
        <Col md={6}>
          <Select
            label={t("requestList.createdBy")}
            name={nameof<typeof filters>("createdBy")}
            value={filters.createdBy}
            onChange={onFilterChange}
            emptyOption={{ value: undefined, text: "" }}
            selectData={
              {
                valueProp: "id",
                textProp: "name",
                data: [
                  {
                    id: +RequestCreatedByEnum.Admin,
                    name: t("common.kindergaten"),
                  },
                  {
                    id: +RequestCreatedByEnum.Applicant,
                    name: t("common.websystem"),
                  },
                ] as CodeBook[],
              } as SelectData<CodeBook>
            }
          />
        </Col> 
          <Col md={6}>
            <Select
              label={t("requestList.institution")}
              name={nameof<typeof filters>("institutionId")}
              value={filters.institutionId}
              onChange={onFilterChange}
              emptyOption={{ value: undefined, text: "" }}
              selectData={
                {
                  valueProp: "id",
                  textProp: "name",
                  data: institutions,
                } as SelectData<CodeBook>
              }
            />
          </Col>          
        </Row>        
      <Row>
          <Col md={6}>
          <Select
            label={t("locationPrograms.location")}
            name={nameof<typeof filters>("locationId")}
            value={filters.locationId}
            onChange={onFilterChange}
            emptyOption={{
              value: undefined,
              text: "",
            }}
            selectData={
              {
                valueProp: "id",
                textProp: "name",
                data: locations,
              } as SelectData<CodeBook>
            }
          />
        </Col>
        </Row>
    </>
  );
};
